import { JsonApiQuery } from '@nx-icilalune/data/access';
import { ColorTerm } from '@nx-icilalune/data/icilalune/types';

const filters = { ['menuInternalId']: 'custom-menu-main' };
export const mainMenuQuery: JsonApiQuery = {
  queryId: 'mainMenu',
  type: 'menuLinks',
  include: ['colorId'],
  fields: {
    [ColorTerm.type]: ['name'],
  },
  relationAttributeEnhancers: ['colorId.name'],
  filters,
  errorMessage: 'errors.main-menu.message',
};
